// loads scripts that need to be on page - every entrypoint should import this!
import { AdLoader, lazyload } from '@datagraphics/cookbook';
import { render } from './map.js';
import { faq } from './faq.js';

document.addEventListener('DOMContentLoaded', () => {
  // Kickstart image lazy loading
  lazyload();
  // Kickstart ads
  const adLoader = new AdLoader({ adSection: window.AD_SECTION });
  adLoader.init();
});

let mapElement = document.getElementById('explore-map');

async function main() {
  // render point map
  render(mapElement, 'Los Angeles');

  // faq js
  faq();
}
main().catch(console.error);
